import moment from "moment";

export function debounce(fn, delay) {
  var timeoutID = null;
  return function() {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function() {
      fn.apply(that, args);
    }, delay);
  };
}

export function determineIsIdle(time) {
  var date1 = moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss");
  var date2 = moment(time);
  var diff = date2.diff(date1, "minutes");

  if (Math.abs(diff) > 5) {
    return true;
  }
  return false;
}
